import { authHeader } from './auth-header';
import axios from 'axios';

export const userService = {
    login,
    logout,
    register,
    getAll,
};

function clearAdminScreenLock() {
    localStorage.removeItem('adminScreenLocked');
    if (typeof document !== 'undefined') {
        document.body.classList.remove('admin-screen-lock-active');
    }
    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('toofacyl:admin-lock-cleared'));
    }
}

function login(email, password) {
    clearAdminScreenLock();
    /*
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
    };
    */
    return new Promise(function(resolve, reject){
        axios.post(`${process.env.VUE_APP_API}/api/user/login`,{
            user:email,
            pass:password
        })
        .then(handleResponse)
        .then(loginData => {
            clearAdminScreenLock();
            localStorage.setItem('user', JSON.stringify(loginData.user));
            if (loginData.token) {
                localStorage.setItem('token', loginData.token);
            } else {
                localStorage.removeItem('token');
            }
            resolve(loginData.user)
        })
        .catch(error => {
            reject(error);
        })
    })
    
    
    
    /*
    return fetch(`/api/user/login`, requestOptions)
        .then(handleResponse)
        .then(user => {
            // login successful if there's a jwt token in the response
            if (user.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user));
            }
            return user;
        });
        */
}

function logout() {
    // remove user from local storage to log user out
    axios.post(`${process.env.VUE_APP_API}/api/user/logout`).catch(() => {});
    clearAdminScreenLock();
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('activeSolutionKey');
    sessionStorage.removeItem('activeWaiterSession');
    sessionStorage.removeItem('auth.currentUser');
    sessionStorage.removeItem('authUser');
    sessionStorage.removeItem('sessionExpiredMessage');
}

function register(user) {
    return new Promise(function(resolve, reject){
        axios.post(`${process.env.VUE_APP_API}/api/public/register`, user)
            .then(handleResponse)
            .then(resolve)
            .catch(reject)
    })
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };
    return fetch(`/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return new Promise(function(resolve,reject){
        if(response.data.valid){
            resolve(response.data)
        }else{
            reject(response.data && response.data.msg ? response.data.msg : "No se pudo iniciar sesión")
        }
    })
    /*
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
    */
}
